import { useCallback, useMemo } from "react";

import type { CalendarSelection } from "./Calendar";
import { isSameDay, startOfDay } from "./dateUtils";

export interface UseDateSelectionParams {
  value: Date | null;
  onChange: (value: Date) => void;
}

/**
 * 단일 날짜 선택(RFC-date-picker §확장성). range와 같은 Calendar를 공유하려 `CalendarSelection`을 만족한다:
 * 선택일은 endpoint(채운 원), 밴드는 없음(isInRange 항상 false). controlled-only.
 */
export function useDateSelection({ value, onChange }: UseDateSelectionParams): CalendarSelection {
  const selectDate = useCallback((date: Date) => onChange(startOfDay(date)), [onChange]);

  return useMemo(
    () => ({
      selectDate,
      isEndpoint: (date: Date) => isSameDay(date, value),
      isInRange: () => false,
    }),
    [selectDate, value],
  );
}
